import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from '@/shared/utils/requests';
import {createSlice} from '@reduxjs/toolkit';
import {handleAsyncRequest} from '../utils';
import {RECORDS_PER_PAGE} from '@/shared/constants/regionsConstants';

const initialState = {
  error: null,
  isLoading: false,
  list: [],
  currentData: [],
};

export const slice = createSlice({
  name: 'regions',
  initialState,
  reducers: {
    hasError: (state, action) => {
      state.error = action.payload;
    },
    startLoading: (state) => {
      state.isLoading = true;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    setRegionsList: (state, action) => {
      state.list = action.payload;
    },
    setCurrentData: (state, action) => {
      state.currentData = action.payload;
    },
    addRegionToList: (state, action) => {
      state.list.push(action.payload);
    },
    updateRegion: (state, action) => {
      const foundIndex = state.list.findIndex(
        ({id}) => id === action.payload.id
      );
      state.list[foundIndex] = {
        ...state.list[foundIndex],
        ...action.payload,
      };
    },
    deleteRegion(state, action) {
      state.list = state.list?.filter(({id}) => id !== action.payload);
    },
  },
});

export default slice.reducer;
const actions = slice.actions;

// Export actions
export const {
  hasError,
  startLoading,
  stopLoading,
  setRegionsList,
  setCurrentData,
} = actions;

// Selectors
export const getAllRegions = (state) => state.regions.list;

export const getRegionById =
  ({regionId}) =>
  (state) =>
    state.regions.list.find(({id}) => {
      return id === regionId;
    });

// Fetch Region
export const fetchRegions = () => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: getRequest,
    endpoint: '/regions',
    toastMessage: {success: {show: false}, error: {show: true}},
  });

  if (error) throw error;

  dispatch(actions.setRegionsList(body?.regions));

  const initialData = body?.regions.slice(0, RECORDS_PER_PAGE);
  dispatch(actions.setCurrentData(initialData));
};

// Create Product
export const createNewRegion = (data) => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: postRequest,
    endpoint: '/regions',
    payload: data,
    toastMessage: {success: {show: true}, error: {show: true}},
  });

  if (error) throw error;
  else {
    dispatch(actions.addRegionToList(body?.region));
    return body?.region;
  }
};

export const updateRegion = (data) => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: patchRequest,
    endpoint: `/regions/${data?.id}`,
    payload: data,
    toastMessage: {success: {show: true}, error: {show: true}},
  });

  if (error) throw error;
  else {
    dispatch(actions.updateRegion(body?.region));
    return body?.region;
  }
};

// Delete Region
export const deleteRegion = (data) => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: deleteRequest,
    endpoint: `/regions/${data?.id}`,
    payload: data,
    toastMessage: {success: {show: true}, error: {show: true}},
  });

  if (error) throw error;
  else dispatch(actions.deleteRegion(data?.id));
};
